import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CatalogData, Linea } from '../models/catalog.model';

interface SnapshotResponse {
  productos: any[];
  categorias?: any[];
  lineas?: any[];
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private apiUrl = '/assets/api/productos.json';

  constructor(private http: HttpClient) {}

  /**
   * Obtiene el catálogo completo (productos, categorías, líneas) desde el JSON
   */
  getCatalog(): Observable<CatalogData> {
    return this.http.get<SnapshotResponse>(this.apiUrl).pipe(
      map((response) => ({
        productos: response?.productos ?? [],
        categorias: response?.categorias ?? [],
        lineas: (response?.lineas ?? []).map((linea) => this.transformLinea(linea))
      })),
      catchError((error) => {
        console.error('Error al cargar catálogo desde API:', error);
        return of({
          productos: [],
          categorias: [],
          lineas: []
        });
      })
    );
  }

  private transformLinea(linea: any): Linea {
    return {
      nombre: linea.nombre || '',
      slug: linea.slug || '',
      lineaSlug: linea.slug || '', // Mapeamos slug a lineaSlug para las rutas
      orden: linea.orden ?? 0,
      descripcion: linea.descripcion,
      metaDescription: linea.metaDescription,
      metaTitle: linea.metaTitle,
      keywords: linea.keywords,
      imagen: linea.imagen,
      activa: linea.activa ?? true,
      descripcionSEO: linea.descripcionSEO
    };
  }
}

